import { render } from "./RecRequest.vue?vue&type=template&id=2c85f9ee&scoped=true"
import script from "./RecRequest.vue?vue&type=script&lang=ts"
export * from "./RecRequest.vue?vue&type=script&lang=ts"

import "./RecRequest.vue?vue&type=style&index=0&id=2c85f9ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c85f9ee"

export default script